import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function PullQuote({ children }: Props) {
  return (
    <section className="mx-auto max-w-4xl px-6 py-24">
      <motion.blockquote
        initial={{ opacity: 0, x: -8 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: '-100px' }}
        transition={{ duration: 0.5 }}
        className="font-display text-3xl md:text-5xl tracking-tight2 leading-tight border-l-2 border-accent pl-8 text-ink"
      >
        {children}
      </motion.blockquote>
    </section>
  );
}
